// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"2e987358","52":"3a879803","53":"08216918","80":"77772a43","197":"f54f6d1c","477":"3d2bc78b","879":"d8b2baf0"}[chunkId] + ".js";
};